import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import style from './style.module.css';
import { faArrowLeft, faArrowLeftRotate, faArrowRight, faLeftLong, faSeedling } from '@fortawesome/free-solid-svg-icons';

import { ContributionCalendar } from 'react-contribution-calendar';
import ActivityItem from '../../parts/ActivityItem/ActivityItem';
import PartItem from '../../parts/PartItem/PartItem';

import { 
    userActivity, getUserContData, getUserActivity, 
    setUserActivityData, getLatestMonthData, ActivityData, LatestMonthDataSingle, 
    Language, getLanguageShortname, 
    getUserContYears, systemLanguage, getLanguageArray, getLabel,
    activityLabel, getItemsPerPage,
    activeDaysLabel,
    noActivityAvailableLabel,
    activityIntroTextLabel,
    activityLogLabel
} from '../../utils/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const itemsPerPage = getItemsPerPage()

const Activity: React.FC = () => {

    const { user_uuid  } = useParams();

    const activityData = getUserContData();
    const years = getUserContYears();

    const today = new Date();
    const [endDate,setEndDate] = useState(today.toISOString().split("T")[0]); 

    const [userData,setUserData] = useState<boolean>(false);

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    oneYearAgo.setDate(oneYearAgo.getDate() + 7);
    const [startDate,setStartDate] = useState(oneYearAgo.toISOString().split("T")[0]);

    const [userLanguage, setUserLanguage] = useState<{ short: string | any } | false>(false);
    const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

    const user_language = getLanguageShortname();
    useEffect(() => {
        if (user_language) {
            setUserLanguage({ short: user_language.toUpperCase() });
        } else {
            setUserLanguage({ short: ((user_language as unknown) as Language).short || 'EN' });
        }
    }, [user_language]);

    const [activeYear,setActiveYear] = useState(today.getFullYear());

    const [cellSize, setCellSize] = useState(10);

    const parsedUserActivityData: ActivityData = JSON.parse(getUserActivity());
    const [activity, setActivity] = useState<LatestMonthDataSingle[]>(
        getLatestMonthData(parsedUserActivityData, true) as LatestMonthDataSingle[]
    );

    const [currentPage, setCurrentPage] = useState(1);

    const allActivities = activity.flatMap(monthData => 
        monthData.activities.map(item => ({...item, month: monthData.month, year: monthData.year}))
    );

    const totalPages = Math.ceil(allActivities.length / itemsPerPage);
    const currentItems = allActivities.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));

    const handleChangeYear = (year: number) => {
        const today = new Date();
        setActiveYear(year);
        if (year === today.getFullYear()) {
            setEndDate(today.toISOString().split("T")[0]);
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(today.getFullYear() - 1);
            oneYearAgo.setDate(oneYearAgo.getDate() + 7);
            setStartDate(oneYearAgo.toISOString().split("T")[0]);
        } else {
            setStartDate(`${year}-01-01`);
            setEndDate(`${year}-12-31`);
        }
        setCurrentPage(1); 
    };


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1368) setCellSize(9)
            else if(window.innerWidth < 1568) setCellSize(10)
            else setCellSize(12)
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === userActivity && event.newValue) {
                try {
                    const parsedNewUserActivityData = JSON.parse(event.newValue);
                    setActivity(getLatestMonthData(parsedNewUserActivityData,true) as LatestMonthDataSingle[]);
                    setUserActivityData(event.newValue); 
                } catch (e) {
                    console.error("Failed to parse updated user activity from storage:", e);
                }
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    useEffect(() => {
        const handler = (e: StorageEvent) => {
            if (e.key === systemLanguage && e.newValue) {
                setSessionLang(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    

    if(!userData){
        return (
            <>
                <div>No Data</div>
            </>
        )
    }

    return (
        <div className={style.scoreboard}>
            <div className={style.header}>
                <div className={`${style.greeting} ${style.textContainerGrad}`}>
                    {getLabel(activityLabel, sessionLang)}
                </div>
                <div className={style.info}>
                    {getLabel(activityIntroTextLabel, sessionLang)}
                </div>
            </div>

            <div className={style.activityLog}>
                <div className={`${style.sectionTitle} ${style.smaller}`}>
                    {activityData.length} {getLabel(activeDaysLabel, sessionLang)}
                </div>
                <div className={style.activity}>
                    <div className={style.contribution}>
                        <div className={style.chart}>
                            <ContributionCalendar
                                data={activityData}
                                start={startDate}
                                end={endDate}
                                textColor="#1F2328"
                                startsOnSunday={true}
                                includeBoundary={true}
                                cx={cellSize}
                                cy={cellSize}
                                cr={0}
                                onCellClick={(e, data) => console.log(data)}
                                scroll={false}
                                style={{padding: '4px'}}
                                theme={{
                                    level0: '#ebedf0',
                                    level1: '#996EC5',
                                    level2: '#7746AA',
                                    level3: '#4C1684',
                                    level4: '#642C9C',
                                }}
                            />
                        </div>
                    </div>
                    <div className={style.years}>
                        {years.map((year) => (
                            <PartItem key={year} active={parseInt(year) === activeYear} label={year} click={() => handleChangeYear(parseInt(year))} />
                        ))}
                    </div>
                </div>
            </div>

            <div className={style.activityLog}>
                <div className={style.activities}>
                    <div className={`${style.sectionTitle} ${style.smallest}`}>
                        {getLabel(activityLogLabel, sessionLang)}
                    </div>
                    {currentItems.length > 0 && userLanguage ? (
                        currentItems.map((item, index) => (
                            <ActivityItem
                                key={index}
                                content={userLanguage ? item.content[userLanguage.short] : ''}
                                date={item.date}
                                indicator={item.indicator}
                                points={item.points !== false ? item.points : undefined}
                            />
                        ))
                    ) : (
                        <div className={style.noActivity}>
                            {getLabel(noActivityAvailableLabel, sessionLang)}
                        </div>
                    )}

                    {/* Styled Pagination */}
                    {totalPages > 1 && (
                        <div className={style.paginationContainer}>
                            <button 
                                className={style.paginationBtn} 
                                onClick={handlePrevPage} 
                                disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <span className={style.paginationInfo}>
                                {currentPage} / {totalPages}
                            </span>
                            <button 
                                className={style.paginationBtn} 
                                onClick={handleNextPage} 
                                disabled={currentPage === totalPages}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Activity;
